
/**
 * @fileoverview The file mananage dT Theme cookie based wishList 
 * dT_General.js, axios, vue libs are dependencies. 
 * @package
 */
class dT_WhistList {

    constructor() {
        this.wishListData = [];

        this.LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
        this.LOCAL_STORAGE_DELIMITER = ',';
        this.DEBUG = true; // Set to false in production
    }
    
    log(message, data) {
        if (this.DEBUG) {
            console.log('[Wishlist Debug]', message, data || '');
        }
    }

    setListLocalStorageKey(LOCAL_STORAGE_WISHLIST_KEY, LOCAL_STORAGE_DELIMITER) {
        this.LOCAL_STORAGE_WISHLIST_KEY = LOCAL_STORAGE_WISHLIST_KEY;
        this.LOCAL_STORAGE_DELIMITER = LOCAL_STORAGE_DELIMITER;
    }

    setupGrid(listType) {
        var wishlist = this.getWishlist();
        this.log('Setting up grid with items:', wishlist);

        var requests = wishlist.map(function (handle) {
            var productTileTemplateUrl = '/products/' + handle + '?view=json';

            var getProductsList =  this.getProductResponse(productTileTemplateUrl);

            return getProductsList;
        }.bind(this));
      

       return Promise.all(requests).then(function (responses) {
              var wishlistProductCards = responses.join('%$$%');
              var wishlistProductCards = wishlistProductCards;

              var a_wishlistRecords = wishlistProductCards.split("%$$%");

              let recordsObj = [];

              if (Array.isArray(a_wishlistRecords) && a_wishlistRecords.length) {
                  var index = 0;
                  a_wishlistRecords.forEach(record => {
                      var a_record = record.split("~~");

                      var product_handle = a_record[2];
                      var product_url = '/products/' + product_handle;
                      var product_image = a_record[3];
                      var product_title = a_record[1];
                      var money_price = a_record[6];
                      var variant_id = a_record[11];
                      var stock_status = a_record[16] || 'in_stock';
                      var total_inventory = a_record[17] || '0';
                      var variant_count = a_record[18] || '1';
                      var available = a_record[9] || 'true';

                      var recordObj = {
                              id:             a_record[0],
                              product_handle: product_handle,
                              product_url: product_url,
                              product_image: product_image,
                              product_title: product_title,
                              money_price: money_price,
                              variant_id: variant_id,
                              stock_status: stock_status,
                              total_inventory: total_inventory,
                              variant_count: variant_count,
                              available: available,
                              price_varies:   a_record[10],
                              variant_title:  a_record[12],
                              sku:            a_record[13],
                              quantity:       "1",
                              product_url:    '/products/'+a_record[2]
                      };

                      recordsObj[index] = recordObj;

                      index = index + 1;

                  });

              }

              return recordsObj;

         }).then(function(data) {
         
             this.wishListData = data;  
         
             return data;

         }.bind(this));

    }

    getWishListRecords()
    {
        return this.wishListData;
    }

    getCompareListRecords()
    {
        return this.wishListData;
    }

    getProductResponse(url) {
      this.log('Fetching product data from:', url);
      
      var responseResult = fetch(url)
        .then((response) => {
          this.log('Response status:', response.status);
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.text();
        })
        .then((data) => {
          this.log('Product data received:', data.substring(0, 100) + '...');
          return data.replace(/^\s*[\r\n]/gm, '');
        })
        .catch((error) => {
          console.error('[Wishlist Error] Failed to fetch product:', url, error);
          return '';
        });
     
      return responseResult;
    }

    getTotalCount() {
        var count = this.getWishlist().length;
        this.log('Total count:', count);
        return count;
    }
  
    getWishlist() {
        var wishlist = localStorage.getItem(this.LOCAL_STORAGE_WISHLIST_KEY) || false;
        var items = wishlist ? wishlist.split(this.LOCAL_STORAGE_DELIMITER) : [];
        this.log('Get wishlist:', items);
        return items;
    }

    setWishlist(array) {
        var wishlist = array.join(this.LOCAL_STORAGE_DELIMITER);
        if (array.length) localStorage.setItem(this.LOCAL_STORAGE_WISHLIST_KEY, wishlist);
        else localStorage.removeItem(this.LOCAL_STORAGE_WISHLIST_KEY);
        this.log('Set wishlist:', array);
        return wishlist;
    }

    updateWishlist(handle) {
        var wishlist = this.getWishlist();
        var indexInWishlist = wishlist.indexOf(handle);
        if (indexInWishlist === -1) {
            wishlist.push(handle);
            this.log('Added to wishlist:', handle);
        } else {
            wishlist.splice(indexInWishlist, 1);
            this.log('Removed from wishlist:', handle);
        }
        return this.setWishlist(wishlist);
    }

    removeWhishlist(handle) {
        var wishlist = this.getWishlist();
        this.log('Removing from wishlist:', handle);
        wishlist = this.remove(wishlist, handle);
        return this.setWishlist(wishlist);  
    }

    resetWishlist() {
        return this.setWishlist([]);
    }
    
    clearWishlistAndReload() {
        this.resetWishlist();
        // Update badge count to 0
        const badge = document.querySelector('.dtxc-wishlist-count');
        if (badge) {
            badge.setAttribute('count', '0');
        }
        // Reload page to reflect changes
        window.location.reload();
    }

    isAddedIntoList(handle) {
        var wishlist = this.getWishlist();  
        
        return wishlist.includes(handle);
    }

    remove(arr) {
        var what, a = arguments, L = a.length, ax;
        while (L > 1 && arr.length) {
            what = a[--L];
            while ((ax= arr.indexOf(what)) !== -1) {
                arr.splice(ax, 1);
            }
        }
        return arr;
    };
}


async function getDTProduct(url) {
    
 
    try {
      let res = await fetch(url);

      return res.text().then(function (text) {      
        return text;
      });

        
    } catch (error) {
        //console.log(error);
    }
}

class dTXWhishList extends HTMLElement {
    constructor() {
      super();

      this.dTWhistList = new dT_WhistList();

      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 500);


      this.addWishList = this.querySelector('.add-wishlist');
     
      this.productHandle = this.addWishList.getAttribute('data-product_handle'); 
      this.addWishList.addEventListener('click', this.debouncedOnSubmit.bind(this));

      this.initLoad();
    }

    onSubmitHandler(event) {
        event.preventDefault();

        if (this.dTWhistList.isAddedIntoList(this.productHandle)) {
            // Item already in wishlist - remove it (toggle off)
            this.addWishList.classList.add("removing");
            this.dTWhistList.updateWishlist(this.productHandle);
            
            setTimeout(() => {
                this.addWishList.classList.remove("removing", "added");
                this.updateBadgeCount();
            }, 500);
        } else {
            // Add to wishlist
            this.addWishList.classList.add("adding");
            this.dTWhistList.updateWishlist(this.productHandle);
            setTimeout(this.postAdd.bind(this), 1000);
        }
    }

    postAdd() {
        this.updateBadgeCount();
        this.addWishList.classList.remove("adding");
        this.addWishList.classList.add("added");
    }
    
    updateBadgeCount() {
        const badge = document.querySelector(".dtxc-wishlist-count");
        if (badge) {
            const count = this.dTWhistList.getTotalCount();
            badge.setAttribute('count', count);
            
            // Also update the span directly for immediate visual feedback
            const badgeSpan = badge.querySelector('span');
            if (badgeSpan) {
                badgeSpan.textContent = count;
            }
            
            this.dTWhistList.log('Updated badge count to:', count);
        }
    }

    initLoad() {
        if (this.dTWhistList.isAddedIntoList(this.productHandle)) {
            this.addWishList.classList.add("added");
        }    
    }
}    

customElements.define('dtx-wishlist', dTXWhishList);



class dTXCompare extends HTMLElement {
    constructor() {
      super();

      this.dTWhistList = new dT_WhistList();
      this.dTWhistList.setListLocalStorageKey('dt-compare-list', ',');

      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 500);


      this.addWishList = this.querySelector('.add-compare');
      this.productHandle = this.addWishList.getAttribute('data-product_handle');

      this.addWishList.addEventListener('click', this.debouncedOnSubmit.bind(this));

      this.initLoad();
    }

    onSubmitHandler(event) {
        event.preventDefault();

        if (this.dTWhistList.isAddedIntoList(this.productHandle)) {
             window.location = "/pages/compare";
        } else {
            this.addWishList.classList.add("adding");

            this.dTWhistList.updateWishlist(this.productHandle);

            setTimeout(this.postAdd.bind(this), 1000);
        }
    }

    postAdd() {
        document.querySelector(".dtxc-compare-count").setAttribute(
          'count', 
          this.dTWhistList.getTotalCount()
        );
      
        this.addWishList.classList.remove("adding");
        this.addWishList.classList.add("added");   
    }

    initLoad() {
        if (this.dTWhistList.isAddedIntoList(this.productHandle)) {
            this.addWishList.classList.add("added");
        }    
    }
}    

customElements.define('dtx-compare', dTXCompare);



class dTXWhishListGrid extends HTMLElement {
    constructor() {
        super();
         
        this.gridTemplate = this.querySelector('.grid_template');

        // Support both old table and new grid layout
        this.dtxTable = this.querySelector(".dtx-table");
        this.wishlistGrid = this.querySelector(".wishlist-grid");
        this.dtxNoRecord = this.querySelector(".dtx-grid-empty");
      
        this.grid_type = this.getAttribute('grid_type');
      
        this.isInitialized = false;
    }

    initLoad() {
        // Prevent duplicate initialization
        if (this.isInitialized) {
            console.log('[Wishlist Debug] Grid already initialized, skipping duplicate load');
            return;
        }

        var dTWhistList = new dT_WhistList();
        if ("compareList" == this.grid_type) {
          dTWhistList.setListLocalStorageKey('dt-compare-list', ',');
        }
        
        this.isInitialized = true;

        dTWhistList.setupGrid().then(function(data) {
           this.generateGrid(data);
          
           return data;
        }.bind(this));
 
   }
  
   generateGrid(a_records) {
      console.log('[Wishlist Grid] generateGrid called with:', a_records);
      console.log('[Wishlist Grid] Records count:', a_records ? a_records.length : 0);
      console.log('[Wishlist Grid] Grid template:', this.gridTemplate);
      console.log('[Wishlist Grid] Wishlist grid container:', this.wishlistGrid);
      console.log('[Wishlist Grid] Empty state element:', this.dtxNoRecord);
      
      if (!a_records || a_records.length === 0 || typeof a_records[0].product_handle === 'undefined') {
        // No records - show empty state
        console.log('[Wishlist Grid] No valid records, showing empty state');
        if (this.dtxTable) this.dtxTable.classList.add("dtx-grid-hide");
        if (this.wishlistGrid) this.wishlistGrid.style.display = 'none';
        this.dtxNoRecord.classList.add("dtx-grid-show");
        this.dtxNoRecord.classList.remove("dtx-grid-hide");
        return;
      }

      // Hide empty state
      console.log('[Wishlist Grid] Hiding empty state, showing items');
      this.dtxNoRecord.classList.add("dtx-grid-hide");
      this.dtxNoRecord.classList.remove("dtx-grid-show");

      // Check if using new grid layout or old table layout
      if (this.wishlistGrid) {
        // NEW GRID LAYOUT
        console.log('[Wishlist Grid] Using new grid layout');
        this.wishlistGrid.style.display = 'grid';
        
        a_records.forEach(function(record, index) {
          console.log('[Wishlist Grid] Processing record', index, ':', record);
          
          var newCard = this.gridTemplate.cloneNode(true);
          newCard.id = 'row_' + record.product_handle;
          newCard.style.display = 'block';
          newCard.classList.remove('grid_template');
          
          // Replace placeholders with actual data
          var cardHTML = newCard.innerHTML;
          console.log('[Wishlist Grid] Original card HTML length:', cardHTML.length);
          
          cardHTML = cardHTML.replace(/{item.product_handle}/gi, record.product_handle);
          cardHTML = cardHTML.replace(/{item.product_url}/gi, record.product_url);
          cardHTML = cardHTML.replace(/{item.product_image}/gi, record.product_image);
          cardHTML = cardHTML.replace(/{item.product_title}/gi, record.product_title);
          cardHTML = cardHTML.replace(/{item.money_price}/gi, record.money_price);
          cardHTML = cardHTML.replace(/{item.variant_id}/gi, record.variant_id);
          
          newCard.innerHTML = cardHTML;
          
          // Add stagger delay for animation
          newCard.style.animationDelay = (index * 0.1) + 's';
          
          this.wishlistGrid.appendChild(newCard);
          console.log('[Wishlist Grid] ✓ Added card for:', record.product_title);
        }.bind(this));
        
        console.log('[Wishlist Grid] Total cards added:', a_records.length);
        console.log('[Wishlist Grid] Grid children count:', this.wishlistGrid.children.length);
        
      } else if (this.dtxTable) {
        // OLD TABLE LAYOUT (fallback)
        console.log('[Wishlist Grid] Using old table layout');
        this.dtxTable.classList.add("dtx-grid-show");
        this.dtxTable.classList.remove("dtx-grid-hide");
        
        a_records.forEach(function(record) {
          var newRow = this.dtxTable.insertRow(this.dtxTable.rows.length);
          newRow.id = 'row_' + record.id;
          newRow.innerHTML = this.buidRow(record);
        }.bind(this));
      }
  }
  
  buidRow(record) {
    var templateData = this.gridTemplate.innerHTML;
    templateData = templateData.replace(/{item.product_handle}/gi, record.product_handle);
    templateData = templateData.replace(/{item.product_url}/gi,    record.product_url);
    templateData = templateData.replace(/{item.product_image}/gi,  record.product_image);
    templateData = templateData.replace(/{item.product_title}/gi,  record.product_title);
    templateData = templateData.replace(/{item.money_price}/gi,    record.money_price);
    templateData = templateData.replace(/{item.variant_id}/gi,     record.variant_id);
    templateData = templateData.replace(/{item.stock_status}/gi,   record.stock_status || 'in_stock');
    templateData = templateData.replace(/{item.total_inventory}/gi, record.total_inventory || '0');
    templateData = templateData.replace(/{item.variant_count}/gi,  record.variant_count || '1');
    templateData = templateData.replace(/{item.available}/gi,      record.available || 'true');
    
    return templateData;
  }
  
  connectedCallback() {
    // console.log('Custom square element added to page.');
     this.initLoad();
  }
  
  
}

customElements.define('dtx-wishlist-grid', dTXWhishListGrid);



class dTXRemoveWishItem extends HTMLElement {
  
    constructor() {
        super();
         
        this.removeItem = this.querySelector('.remove-item');


        this.debouncedOnSubmit = debounce((event) => {
      	  this.removeListItem(event);
      	}, 500);

      
        this.grid_type = this.getAttribute('grid_type');
      
        this.productHandle = this.removeItem.getAttribute('data-product_handle');

        this.removeItem.addEventListener('click', this.debouncedOnSubmit.bind(this));

    }
  
    removeListItem(event)
    {
      event.preventDefault();
      
      var dTWishList = new dT_WhistList();
      if ("compareList" == this.grid_type) {
        dTWishList.setListLocalStorageKey('dt-compare-list', ',');
      }
        

      dTWishList.removeWhishlist(this.productHandle);
      
      window.location.reload();
    }  
  
}

customElements.define('dtx-remove-wish-item', dTXRemoveWishItem);



class dTXWishCount extends HTMLElement {
  
  static get observedAttributes() {
    return ['count'];
  }  
  
  constructor() {
      super();
         
      this.gridCountBubble = this.querySelector('.grid-count-bubble');
      
      this.grid_type = this.getAttribute('grid_type');
      
      this.isInitialized = false;
     
      this.initLoad();
  }
  
  initLoad() {
      // Only load from localStorage on initial load
      if (this.isInitialized) return;
      
      var dTWishList = new dT_WhistList();
      if ("compareList" == this.grid_type) {
        dTWishList.setListLocalStorageKey('dt-compare-list', ',');
      }
      
      var totalCount = dTWishList.getTotalCount();
      
      this.updateDisplay(totalCount);
      
      this.isInitialized = true;
  }
  
  updateDisplay(count) {
      if (this.gridCountBubble && this.gridCountBubble.querySelector("span")) {
          this.gridCountBubble.querySelector("span").innerHTML = count;
      }
  }
  
  attributeChangedCallback(name, oldValue, newValue) {
      // When count attribute changes, just update the display
      // Don't re-read from localStorage to avoid double-counting
      if (name === 'count' && newValue !== oldValue && this.isInitialized) {
          this.updateDisplay(newValue);
      }
  }
  
  
}

customElements.define('dtx-wish-count', dTXWishCount);



function makeTimer() {

  $('.product-deal-count').each(function() {
   
    var endTime = new Date($(this).attr('data-end-time'));		
    endTime = (Date.parse(endTime) / 1000);

    var now = new Date();
    now = (Date.parse(now) / 1000);

    var timeLeft = endTime - now;
    
    if(timeLeft > 0) {
      var days = Math.floor(timeLeft / 86400); 
      var hours = Math.floor((timeLeft - (days * 86400)) / 3600);
      var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600 )) / 60);
      var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));

      if (hours < "10") { hours = "0" + hours; }
      if (minutes < "10") { minutes = "0" + minutes; }
      if (seconds < "10") { seconds = "0" + seconds; }

      $(this).find(".days").html(days + "<span>Days</span>");
      $(this).find(".hours").html(hours + "<span>Hrs</span>");
      $(this).find(".minutes").html(minutes + "<span>Mins</span>");
      $(this).find(".seconds").html(seconds + "<span>Secs</span>");	
      
    } else {
      $(this).find(".notice").html("<span>Expired</span>");
    }
    
  });

}

setInterval(function() { makeTimer(); }, 1000);
    


var swiper = new Swiper("#swiper-sidebar-carousel", {        
  slidesPerView: 1,
  navigation: {
    nextEl: "#swiper-sidebar-next",
    prevEl: "#swiper-sidebar-prev",
  },
});


$(document).on('click', '.color-values', function () {
  if ($(this).hasClass("active")) {
    $(".color-values").removeClass("active");
  } else {
    $(".color-values").removeClass("active");
    $(this).addClass("active");
  }
});
$('body').on('click', '.swatch-element.color', function () {
  $(this).next('label').find('i');
});
$('body').on('click', '.swatch span', function () {
  var featuredMedia =  $(this).parents('.card-wrapper').find('.card__inner .motion-reduce').attr('srcset', $(this).data("image"));
  $(this).parents('.card-wrapper').find('.card__inner .motion-reduce').attr('srcset', $(this).data("image"));

  if ($(this).parents('.swatch').hasClass('color')) {

    var variant = $(this).data('id');
    $(this).parents('#product-grid').find('.variant-push').val(variant);

   var swatch_item = $(this).data('variant-item');

    $(this).parents('#product-grid').find('.variant-option-size .size-values').removeClass('active');

    $(this).parents('#product-grid').find('.variant-option-size .swatch').each(function () {

      var swatch_size_vars = $(this).find('span').data('variant-title');
      swatch_size_vars = swatch_size_vars.split('/');
      swatch_size_vars = $.map(swatch_size_vars, $.trim);
      swatch_size_vars = $.map(swatch_size_vars, function (n) {
        return n.toLowerCase();
      });
      swatch_size_vars = $.map(swatch_size_vars, function (n) {
        return n.replace(/ /g, '-');
      });

      if ($.inArray(swatch_item, swatch_size_vars) >= 0) {
        $(this).parent('.size-values').toggleClass('active');
      }
    });
  }

  if ($(this).parents('.swatch').hasClass('size')) {

    var variant = $(this).data('id');
    $(this).parents('#product-grid').find('.variant-push').val(variant);
  }
});


